import NotFoundComponent from "../components/notFoundComponent";


const NotFoundPage=()=>{

    return(
        <NotFoundComponent/>
    );
};
export default NotFoundPage;